module.exports = __webpack_public_path__ + "static/media/worker_outline.a2e35071.svg";